export const downloadFile = (
  p: {
    a?: HTMLAnchorElement
    fileURL?: string
    filename?: string
  },
  callback?: () => void
) => {
  if (!p.a) {
    if (!!p.fileURL && !!p.filename) {
      p.a = window.document.createElement('a')
      document.body.appendChild(p.a)
      p.a.href = p.fileURL
      p.a.download = p.filename
    } else {
      throw new Error('File url or filename missing for file download!')
    }
  }

  p.a.click()
  setTimeout(() => {
    if (p.fileURL) {
      window.URL.revokeObjectURL(p.fileURL)
    } else {
      return
    }
    
    const parent = p.a?.parentElement
    if (!!p.a && !!parent) {
      parent.removeChild(p.a)
    }
    if (callback) {
      callback()
    }
  }, 100)
}
